// extracted by mini-css-extract-plugin
export default {"productGallery":"mF-z","inQuickShop":"nF-z"};